export default "__VITE_ASSET__BfhLqbRg__"